import { useState, useCallback } from "react";
import { apiClient } from "../../utils/api";
import { ODODetail, ODODetailResponse } from "../../types/cs";

interface UseODODetailReturn {
  odoDetail: ODODetail | null;
  isLoading: boolean;
  error: string;
  fetchODODetail: (odoId: string) => Promise<void>;
  clearDetail: () => void;
}

const useODODetail = (): UseODODetailReturn => {
  const [odoDetail, setOdoDetail] = useState<ODODetail | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchODODetail = useCallback(async (odoId: string) => {
    setIsLoading(true);
    setError("");

    try {
      const response = await apiClient.get("/api/v1/cs/odo/detail", { 
        params: { odo_id: odoId }
      });
      
      const responseData: ODODetailResponse = response.data;

      if (responseData.status) {
        setOdoDetail(responseData.data);
      } else {
        setError("1:1 문의 상세 정보를 불러오는데 실패했습니다.");
      }
    } catch (err) {
      console.error("1:1 문의 상세 조회 오류:", err);
      setError("네트워크 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearDetail = useCallback(() => {
    setOdoDetail(null);
    setError("");
  }, []);

  return {
    odoDetail,
    isLoading,
    error,
    fetchODODetail,
    clearDetail,
  };
};

export default useODODetail;
export type { UseODODetailReturn }; 